import { Facebook, Instagram, MapPin, MessageCircle, Phone } from "lucide-react";
import { MAPS_URL, SOCIAL, waUrl } from "../config";
import { trackCta } from "../attribution";

export const Footer = ({ t }) => (
    <footer data-testid="footer" className="bg-[#1b0b06] py-14 text-[#fbf3e8]">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-5 sm:px-6 md:flex-row md:items-center">
            <div>
                <img src="/logo.png" alt="Matianellu Rio" className="h-14 w-auto rounded-lg bg-[#fbf3e8] p-2" />
                <p className="font-display mt-4 text-lg italic text-[#fbf3e8]/70">{t.footer.tag}</p>
            </div>
            <div className="space-y-3 text-sm">
                <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-[#f23218]">{t.footer.contact}</p>
                <a
                    href={waUrl(t.waMsg)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-whatsapp-link"
                    onClick={trackCta("whatsapp_click", "footer")}
                    className="flex items-center gap-2 font-semibold transition-colors hover:text-[#faff00]"
                >
                    <MessageCircle size={15} /> +55 21 97077-7955
                </a>
                <a href="tel:+552139368240" data-testid="footer-phone-link" onClick={trackCta("phone_click")} className="flex items-center gap-2 font-semibold transition-colors hover:text-[#faff00]">
                    <Phone size={15} /> +55 21 3936-8240
                </a>
                <a
                    href={MAPS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-address-link"
                    className="flex items-center gap-2 font-semibold transition-colors hover:text-[#faff00]"
                >
                    <MapPin size={15} /> R. Emílio Berla, 41 — Copacabana
                </a>
            </div>
            <div className="space-y-3 text-sm">
                <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-[#f23218]">{t.footer.follow}</p>
                <div className="flex items-center gap-3">
                    <a
                        href={SOCIAL.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram-link"
                        aria-label="Instagram"
                        className="flex h-11 w-11 items-center justify-center rounded-full border border-[#fbf3e8]/20 text-[#fbf3e8] transition-all hover:scale-110 hover:border-[#f23218] hover:bg-[#f23218]"
                    >
                        <Instagram size={19} />
                    </a>
                    <a
                        href={SOCIAL.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-facebook-link"
                        aria-label="Facebook"
                        className="flex h-11 w-11 items-center justify-center rounded-full border border-[#fbf3e8]/20 text-[#fbf3e8] transition-all hover:scale-110 hover:border-[#f23218] hover:bg-[#f23218]"
                    >
                        <Facebook size={19} />
                    </a>
                </div>
            </div>
        </div>
        <div className="mx-auto mt-12 max-w-7xl border-t border-[#fbf3e8]/10 px-5 pt-6 sm:px-6">
            <p className="text-xs text-[#fbf3e8]/40">{t.footer.rights}</p>
        </div>
    </footer>
);
